"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.group.demonstrations.accounting", {
        url: "/demonstracoes/contabil",
        views: {
            "demonstrationView@nucont.accounting.group.demonstrations": {
                component: "accountingDemonstrationsComponent",
                bindings: { companyData: "groupData" }
            }
        },
        params: {
            source: { value: "contabil", dynamic: true }
        }
    });
}
